import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Message } from "primereact/message";
import { ApiResponse } from "../../services/base/apiResponse";

const translateStatus = (status: number | "FETCH_ERROR" | "PARSING_ERROR" | "TIMEOUT_ERROR" | "CUSTOM_ERROR") => {
  switch (status) {
    case 401:
      return "Неоторизиран достъп";
    case 403:
      return "Забранен достъп";
    case 404:
      return "Не е намерено";
    case 500:
      return "Сървърна грешка";
    case "FETCH_ERROR":
      return "Грешка при връзка със сървъра";
    case "PARSING_ERROR":
      return "Грешка при обработка (парсване) на данни";
    case "TIMEOUT_ERROR":
      return "Таймаут при извличане на данни";
    case "CUSTOM_ERROR":
      return "Грешка";
    default:
      return "Неизвестна грешка";
  }
};

const Error = ({
  error,
  fullWidth = true,
}: {
  error: FetchBaseQueryError | SerializedError | undefined;
  fullWidth?: boolean;
}) => {
  console.debug("error", error);
  if (!error) return null;
  else if ("data" in error && error.data) {
    const data = error.data as ApiResponse<any>;
    return <Message severity="error" text={data?.errors} title={data?.severity?.toString() ?? "Error"} />;
  } else if ("status" in error) {
    return <Message severity="error" className={fullWidth ? "w-full" : ""} text={translateStatus(error.status)} />;
  } else if ("message" in error) {
    return <Message severity="error" className={fullWidth ? "w-full" : ""} text={error.message} />;
  } else {
    return <Message severity="error" className={fullWidth ? "w-full" : ""} text={JSON.stringify(error)} />;
  }
};

export default Error;
